import { CustomEventOptions } from '@/api/common';
import pkgJson from '../../package.json';
// import { ApmSDK } from './asyncImportJs';
// 该文件为天启埋点引入及应用，本文件提供了一些基础配置及引用
// 更多配置见文档 https://hellobike.yuque.com/gzxsb9/gdvwvw/kegdas

// await ApmSDK();

const { version, name } = pkgJson;
const CATEGORY_ID = 'miaowa';
class TIANQI_UBT {
  static latitude = 0;

  static longitude = 0;

  // 设置配置（必传）
  static setConfig() {
    // ApmSDK().then(() => {
    const { UBT } = (window as any).TianQi;
    UBT.config({
      env: process.env.REACT_APP_ENV, // 必填, 可选值为 dev / fat / uat / pro
      debug: process.env.REACT_APP_ENV !== 'pro', // 选填，调试模式，默认 false，开启后可查看 info/warn/error/InError 类型日志
      categoryId: CATEGORY_ID, // 全局 categoryId，必须英文，常见categoryId见链接 https://hellobike.yuque.com/gzxsb9/gdvwvw/kegdas#3OHPT
      logMaxCount: 3,
      logTimeout: 5000,
    });
    // })
  }

  static getLocation(): Promise<{ [key: string]: any }> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position: any) => {
          const { latitude, longitude } = position?.coords || {};
          TIANQI_UBT.latitude = latitude;
          TIANQI_UBT.longitude = longitude;
          resolve({ latitude, longitude });
        }, (error: any) => {
          reject(error);
        });
      } else {
        reject(new Error('未开启定位'));
      }
    });
  }

  // 采集用户基础信息（必传）
  static bindData({
    longitude = 0,
    latitude = 0,
  }) {
    // h5需绑定在APM的UBT上 通过脚本引入
    // ApmSDK().then(() => {
    const { UBT } = (window as any).TianQi;
    // const APM = (window as any).TianQiApm.UBT;
    // console.log(UBT, 'UBT');
    if (process.env.NODE_ENV !== 'pro') {
      console.log(UBT, 'UBT');
    }

    UBT.bindData({
      appVersion: version || '0.0.1', // 应用的版本
      appName: name, // 由业务线自定义
      userGuid: () => '用户的guid',
      cityCode: () => '用户所在地的citycode',
      cityName: () => '用户所在城市的中文名',
      adCode: () => '用户所在地的adCode',
      // longitude: () => longitude || TIANQI_UBT.longitude,
      longitude() { return longitude || TIANQI_UBT.longitude; },
      // latitude: () => latitude || TIANQI_UBT.latitude,
      latitude() { return latitude || TIANQI_UBT.latitude; },
    });

    // APM.bindData({
    //   appVersion: version || '0.0.1', // 应用的版本
    //   appName: name,
    //   userGuid: () => '用户的guid',
    //   // 监听pageload回调
    //   pageloadCallback: (perforObj: any) => {
    //     console.log(perforObj, 'perforObj');
    //     if (!perforObj) return;
    //     const { firstScreenEnd, navigationStart } = perforObj || {};
    //     const firstScreenEndTime = firstScreenEnd - navigationStart;
    //     // window.firstScreenEndTime = firstScreenEndTime;
    //     console.log('回调性能数据2：', firstScreenEndTime);
    //   },
    // });
    // });
  }
}

/**
* 上报自定义事件
* @param eventId
* @param data
*/
export function reportCustomEvent<T>(
  eventId: string,
  options: (CustomEventOptions | T) = {},
) {
  const { UBT } = (window as any).TianQi;
  UBT.customEventWithPointId({
    categoryId: CATEGORY_ID, // 非必填，业务ID
    pointId: eventId, // 必填，事件ID
    businessInfo: options,
  });
}

export {
  TIANQI_UBT,
  CATEGORY_ID,
};
